<template>
    <ul>
        <li @click="$emit('modify', $event)" class="hover:bg-gray-100">
            <a class="flex block px-4 pt-2 pb-3 font-semibold rounded-b-lg cursor-pointer">
                Change account type
            </a>
        </li>
        <li @click="$emit('remove', $event)" class="text-red-500 hover:bg-gray-100">
            <a class="flex block px-4 pt-2 pb-3 font-semibold rounded-b-lg cursor-pointer">Remove account</a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'modify-member',
};
</script>
